import React, { Component } from 'react';
import _ from "lodash";

export default class PropertyEditor extends Component {

    state = {
    };

    constructor(props, context) {
        super(props, context);

        this.debounce = _.debounce(this.tryPropertyValueChanged, 200);
    }

    componentWillMount() {
        this.registerPropertyValueChangedEvent(this.props.source);
    }

    componentWillReceiveProps(nextProps) {
        this.unregisterPropertyValueChangedEvent();
        this.registerPropertyValueChangedEvent(nextProps.source);
    }

    componentWillUnmount() {
        this.disposed = true;
        this.unregisterPropertyValueChangedEvent();
    }

    registerPropertyValueChangedEvent(property) {
        this.unregisterPropertyChangedListener = property.registerPropertyChangedListener((name, valOld, valNew, subName) => {
            // console.log(`onPropertyValueChanged from PropertyEditor: ${property.name}, ${name}`);
            this.debounce(property.name, valOld, valNew, name);

            // this.tryPropertyValueChanged(property.name, valOld, valNew, name);
        });
    }

    unregisterPropertyValueChangedEvent() {
        if (this.unregisterPropertyChangedListener)
            this.unregisterPropertyChangedListener();
    }

    tryPropertyValueChanged(name, valOld, valNew, subName) {
        if (!this.disposed)
            this.onPropertyValueChanged(name, valOld, valNew, subName);
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {

    }
}
